/**
 * Panel definitions for flex/cbmp segment
 * Add your afrr-related panels here based on backend dataset configs
 */
export const flexCbmpPanels = [
  {
    id: 'picasso-cbmp-afrr-prices',
    type: 'datasetChart',
    datasetId: 'entsoe-picasso-cbmp',
    visualizationId: 'picasso-cbmp-chart',
    gridPos: { x: 0, y: 0, w: 24, h: 12 },
  },
  {
    id: 'picasso-cbmp-similarity-matrix',
    type: 'datasetSimilarityMatrix',
    datasetId: 'entsoe-picasso-cbmp',
    visualizationId: 'picasso-cbmp-similarity-matrix',
    gridPos: { x: 0, y: 12, w: 24, h: 24 },
  },
];

export const flexCbmpSyncGroups = [
  {
    id: 'cbmp-global-sync',
    global: false,
    ids: ['picasso-cbmp-afrr-prices', 'picasso-cbmp-similarity-matrix'],
    syncDateRange: true,
    syncGranularity: true,
  },
];
